import React from 'react';
import WarningIconSvg from './WarningIconRed.svg';

const WarningIconRed = ({ style }) => (
    /* TODO - change to 'webpack inlined' when on react-scripts 2.0 - https://facebook.github.io/create-react-app/docs/adding-images-fonts-and-files#adding-svgs */
    <img src={WarningIconSvg} alt="Warning" style={style} />
);

export default WarningIconRed;
